var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ScaleResult } from "../../../shared/models/scale-result";
import { AssessmentHydrator } from "../../../shared/services/assessment-hydrator.service";
import { BaseReportItemComponent } from 'app/reports/models/base-report-item-component';
var ComputedScaleComponent = /** @class */ (function (_super) {
    __extends(ComputedScaleComponent, _super);
    function ComputedScaleComponent(hydrator) {
        var _this = _super.call(this) || this;
        _this.hydrator = hydrator;
        return _this;
    }
    ComputedScaleComponent.prototype.setReportData = function (data, results, variables) {
        var _this = this;
        this._scaleResult = new ScaleResult();
        if (data) {
            if (data.scale) {
                this._scaleResult.scale = this.hydrator.hydrateScale(data.scale);
            }
            // calculation, assessments
            this._calculation = data.calculation || "SUM";
            if (data.items) {
                data.items.forEach(function (i) { return _this.addCalculation(i); });
                this._scaleResult.range = this._scaleResult.scale.getRangeForScore(this._scaleResult.score);
            }
        }
    };
    ComputedScaleComponent.prototype.ngOnInit = function () { };
    ComputedScaleComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    Object.defineProperty(ComputedScaleComponent.prototype, "scaleResult", {
        get: function () {
            return this._scaleResult;
        },
        enumerable: true,
        configurable: true
    });
    ComputedScaleComponent.prototype.addCalculation = function (item) {
        var result = this.results.find(function (r) { return r.assessment.uid == item.assessmentUid; });
        var scaleResult = result ? result.scaleResults.find(function (sr) { return sr.scale.id == item.scaleId; }) : null;
        if (!(result && scaleResult)) {
            return;
        }
        if (this._calculation === "SUM") {
            this._scaleResult.score += scaleResult.score;
        }
    };
    return ComputedScaleComponent;
}(BaseReportItemComponent));
export { ComputedScaleComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/computed-scale/computed-scale.component.ts.pre-build-optimizer.js